export default __webpack_public_path__ + "static/david-lehman-68a717ed1984d7108b523ccc29f04988.jpg";